import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const Refer = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      localStorage.setItem('referralId', id);
      navigate('/register');
    }
  }, [id, navigate]);

  return <div>Redirecting...</div>;
};

export default Refer;
